import Cookies from 'universal-cookie';
import { COOKIE_DOMAIN, CURRENT_COMPANY_ID, CURRENT_IDENTIFIER, CURRENT_PRODUCT, isDevelopment } from './constants';

const props = { domain: COOKIE_DOMAIN, path: '/' };

export const setCookies = (cookieName: string, value : any) : void => {
  const cookies = new Cookies();

  if(isDevelopment()) {
    cookies.set(cookieName, value);
    return;
  }

  cookies.set(cookieName, value, props);
};

export const removeCookies = (cookieName : string) : void => {
  const cookies = new Cookies();

  if(isDevelopment()) {
    cookies.remove(cookieName);
    return;
  }

  cookies.remove(cookieName,  props);
};

export const cleanCookies = async () : Promise<void> => {
  return new Promise((resolve, reject) => {
    try {
      removeCookies(CURRENT_PRODUCT);
      removeCookies(CURRENT_IDENTIFIER);
      removeCookies(CURRENT_COMPANY_ID);

      resolve();
    } catch (error) {
      reject(error);
    }
  });
};